module.exports = __webpack_public_path__ + "img/false.26693f46.png";